<template>
  <label :class="$style.fieldGroup">
    <span :class="$style.checkbox">
      <span :class="[
        $style.box,
        checked && $style.checked,
        errorMessage && $style.hasError,
      ]">
        <UiIconsCheck />
      </span>

      <span
        v-if="label || $slots.label"
        :class="$style.label"
      >
        <slot v-if="$slots.label" name="label" />
        <template v-else>
          {{ label }}
        </template>
      </span>

      <input
        type="checkbox"
        :v-model="checked"
        :class="$style.hidden"
        @change="handleChange"
      />
    </span>
  </label>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate';
import type { CheckboxParams } from './';

const props = defineProps<CheckboxParams>();

const { value: checked, errorMessage, handleChange } = useField<boolean>(() =>
  props.name,
  undefined,
  {
    type: 'checkbox',
    checkedValue: true,
    uncheckedValue: false,
  }
);
</script>

<style lang="scss" module>
  .fieldGroup {
    position: relative;
    display: inline-flex;
    flex-direction: column;
    cursor: pointer;

    &:not(:last-child) {
      margin-bottom: 20px;
    }

    &:hover {

      .box {
        border-color: #3246FF;
      }
    }
  }

  .error {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    text-align: left;
    font-size: 12px;
    color: #FF3C77;
  }

  .checkbox {
    display: flex;
    gap: 0 16px;
    align-items: center;
  }

  .box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 17px;
    height: 17px;
    flex-shrink: 0;
    border-radius: 2px;
    border: 1px solid #F0F0F0;
    background-color: transparent;
    color: #293EFF;
    transition: 200ms ease;

    svg {
      width: 9px;
      height: auto;
      opacity: 0;
      transition: 200ms ease;
    }

    &.checked {
      border-color: #293EFF;
      background-color: #293EFF;
      color: #fff;

      svg {
        opacity: 1;
      }
    }

    &.hasError {
      border-color: #FF3C77;
    }
  }

  .label {
    span, b {
      font-weight: 400;
    }

    a {
      color: #293EFF;
      text-decoration: none;
    }
  }

  .hiddden {
    position: absolute;
    z-index: -10;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    opacity: 0;
  }
</style>